import { navigationItems as rawNavigationItems } from '~/utils/navigation-items';

export default defineNuxtRouteMiddleware((to) => {
  const { showSnackbar } = useSnackbarStore();
  const { $i18n } = useNuxtApp();
  const { t } = $i18n;
  const partner = localStorage.getItem('partnerName');
  let hasPermission = true;

  rawNavigationItems.forEach(function searchNavigation(navigationItem) {
    if (navigationItem.options) {
      navigationItem.options.forEach(searchNavigation);
    }

    if (navigationItem.url && to.fullPath.includes(navigationItem.url)) {
      hasPermission = navigationItem.permission;
    }
  });

  if (!hasPermission) {
    showSnackbar({
      type: 'error',
      message: t('common.forbiddenAccess')
    });

    return navigateTo({
      name: 'partner-home',
      params: { partner }
    });
  }
});
